import '../App.css';
import Calculator from '../components/Calculator';

function Calculate() {
  return (
    <div className="calculate-page">
      <h3>Let us do some math!</h3>
      <Calculator />
    </div>
  );
}

export default Calculate;
